// removed by extract-text-webpack-plugin
module.exports = {"header":"telephone-modal_header--2hcxPLZG","telephoneModal":"telephone-modal_telephoneModal--CPy-T3Fs","body":"telephone-modal_body--1FAvTug9","practice":"telephone-modal_practice--2uWI0JtX","telephone-number":"telephone-modal_telephone-number--2903YsfV","telephoneNumber":"telephone-modal_telephone-number--2903YsfV"};


//////////////////
// WEBPACK FOOTER
// ./components/doctify-modals/src/styles/telephone-modal.scss
// module id = 1669
// module chunks = 0